/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EffectiveCostDtoPage } from '../models/effective-cost-dto-page';
import { listEffectiveCosts } from '../fn/effective-cost/list-effective-costs';
import { ListEffectiveCosts$Params } from '../fn/effective-cost/list-effective-costs';

@Injectable({ providedIn: 'root' })
export class EffectiveCostApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listEffectiveCosts()` */
  static readonly ListEffectiveCostsPath = '/v0/effectiveCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listEffectiveCosts()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEffectiveCosts$Response(params?: ListEffectiveCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveCostDtoPage>> {
    return listEffectiveCosts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listEffectiveCosts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEffectiveCosts(params?: ListEffectiveCosts$Params, context?: HttpContext): Observable<EffectiveCostDtoPage> {
    return this.listEffectiveCosts$Response(params, context).pipe(
      map((r: StrictHttpResponse<EffectiveCostDtoPage>): EffectiveCostDtoPage => r.body)
    );
  }

}
